import { pageDefinition } from 'site-modules/shared/pages/page';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { getModelState } from 'client/data/luckdragon/model';
import { CmsModel } from 'client/data/models/cms';
import { parseContent } from 'client/data/cms/content';
import { getMeta, getSeoImage } from 'site-modules/shared/utils/seo-helper';
import { getListItemSchema } from 'client/seo/schemas/list';
import { BSC_CONTENT_PATH } from 'client/site-modules/infographics/constants/best-selling-cars';

import { BestSellingCars } from './best-selling-cars';

export const pageDefinitionConfiguration = {
  name: 'best_selling_cars',
  category: 'best_selling_cars',
  seo: state => {
    const modelState = getModelState(state);
    const content = modelState.get(`content["${BSC_CONTENT_PATH}"]`, CmsModel);
    const parsedContent = parseContent(content);
    const meta = getMeta(parsedContent);
    const { canonical } = meta;
    const nationalSalesData = parsedContent.child('national-sales');
    const nationalSalesList = nationalSalesData.children().map((child, ind) => ({
      name: child.metadata('vehicleName').value(),
      url: `https://www.edmunds.com${child.metadata('link').value()}`,
      position: ind + 1,
      orderType: 'https://schema.org/ItemListOrderDescending',
    }));

    return {
      ...meta,
      image: getSeoImage(parsedContent),
      jsonld: [
        getListItemSchema({
          items: nationalSalesList,
          name: nationalSalesData.metadata('title').value(),
          isDescendingOrder: true,
          pageUrl: canonical,
        }),
      ],
    };
  },
  preload: store => {
    const preloader = new ModelPreloader(store);
    preloader.resolve(`content["${BSC_CONTENT_PATH}"]`, CmsModel);
    return preloader.load();
  },
  component: BestSellingCars,
};

export default pageDefinition(pageDefinitionConfiguration);
